import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SignInResponse } from "../api/models/SignInResponse";
import { getUser, refreshTokens } from "../api/thunks/users";
import type { RefreshTokenError } from "../api/thunks/users";
import { REFRESH_TOKEN_EXPIRED_CODE } from "../constants/auth";
import { User } from "../api/models/User";

export interface UserState {
  user: User | undefined;
  credentials: SignInResponse | undefined;
}

export const userSlice = createSlice({
  name: "user",
  initialState: {
    user: undefined,
    credentials: undefined,
  } as UserState,
  reducers: {
    setUser: (state, action: PayloadAction<User>) => {
      state.user = action.payload;
    },
    setCredentials: (state, action: PayloadAction<SignInResponse>) => {
      state.credentials = action.payload;
    },
    clearCredentials: (state) => {
      state.user = undefined;
      state.credentials = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUser.fulfilled, (state, action) => {
      state.user = action.payload;
    });

    builder.addCase(refreshTokens.fulfilled, (state, action) => {
      const { payload } = action;
      const { accessToken, refreshToken } = payload;

      if (!state.credentials) {
        state.credentials = { accessToken: "", refreshToken: "" };
      }

      if (accessToken && accessToken.length > 0) {
        state.credentials.accessToken = accessToken;
      }

      if (refreshToken && refreshToken.length > 0) {
        state.credentials.refreshToken = refreshToken;
      }
    });

    builder.addCase(refreshTokens.rejected, (state, action) => {
      const payload = action.payload as RefreshTokenError | undefined;
      if (payload?.code === REFRESH_TOKEN_EXPIRED_CODE) {
        state.user = undefined;
        state.credentials = undefined;
      }
    });
  },
});

export const { setUser, setCredentials, clearCredentials } = userSlice.actions;
export default userSlice.reducer;
